var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import OffCanvasMenu from "../../off-canvas-menu";
import DropdownMenu from "../../dropdown-menu";
// @ts-ignore
import values from "object.values";
import iconArrowLeft from "../images/icon-arrow-left.svg";
import iconArrowRight from "../images/icon-arrow-right.svg";
import iconLock from "../images/icon-lock.svg";
import iconQuestion from "../images/icon-question.svg";
import iconInfo from "../images/icon-info.svg";
import iconBars from "../images/icon-bars.svg";
import iconChevronDown from "../images/icon-chevron-down.svg";
var getItems = function (data) {
    return values(data).map(function (_a, i) {
        var url = _a.url, classes = _a.classes, target = _a.target, title = _a.title;
        return (_jsx("a", __assign({ href: url, className: classes, target: target }, { children: title }), i));
    });
};
var getMenu = function (_a) {
    var label = _a.label, data = _a.data, cssClasses = _a.cssClasses, icon = _a.icon, icon_position = _a.icon_position, label_mobile = _a.label_mobile;
    return (_jsx(DropdownMenu, __assign({ label: getLabel({ label: label, icon: icon, icon_position: icon_position, label_mobile: label_mobile }), cssClasses: cssClasses }, { children: getItems(data) })));
};
var getOffcanvasmenu = function (_a) {
    var data = _a.data, label = _a.label, icon = _a.icon, icon_position = _a.icon_position, cssClasses = _a.cssClasses, label_mobile = _a.label_mobile;
    return (_jsx(OffCanvasMenu, __assign({ label: getLabel({ label: label, icon: icon, icon_position: icon_position, label_mobile: label_mobile }), cssClasses: cssClasses }, { children: getItems(data) })));
};
var getLabel = function (_a) {
    var icon = _a.icon, icon_position = _a.icon_position, label = _a.label, label_mobile = _a.label_mobile;
    return !icon ? (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "hide-on-medium-large-screens" }, { children: label_mobile })), _jsx("span", __assign({ className: "hide-on-small-screens" }, { children: label }))] })) : (_jsxs("span", __assign({ className: "Header__label " + icon_position }, { children: [_jsx("img", { src: icons[icon], "aria-hidden": "true" }), _jsx("span", __assign({ className: "hide-on-medium-large-screens" }, { children: label_mobile })), _jsx("span", __assign({ className: "hide-on-small-screens" }, { children: label }))] })));
};
var getLink = function (_a) {
    var url = _a.url, label = _a.label, icon = _a.icon, icon_position = _a.icon_position, label_mobile = _a.label_mobile, cssClasses = _a.cssClasses;
    return (_jsx("a", __assign({ className: "Header__link ".concat(cssClasses), href: url }, { children: getLabel({ label: label, icon: icon, icon_position: icon_position, label_mobile: label_mobile }) })));
};
var outputs = {
    menu: getMenu,
    link: getLink,
    offCanvasMenu: getOffcanvasmenu,
};
export var getHeaderColumn = function (_a) {
    var _b = _a.options, options = _b === void 0 ? "empty" : _b, mobile_options = _a.mobile_options, menu = _a.menu, link = _a.link, cssClasses = _a.cssClasses;
    if (options === "empty")
        return null;
    var data = options === "menu" || options === "offCanvasMenu" ? menu : link;
    return (outputs[options] &&
        outputs[options](__assign(__assign({}, data), { cssClasses: cssClasses + " " + mobile_options })));
};
var icons = {
    faChevronDown: iconChevronDown,
    faArrowLeft: iconArrowLeft,
    faArrowRight: iconArrowRight,
    faLock: iconLock,
    faBars: iconBars,
    faQuestionCircle: iconQuestion,
    faInfoCircle: iconInfo,
};
